import { NgModule } from '@angular/core';
import { SharedModule } from '~app/app/~shared/modules/shared.module';
import { AdvertiserGroupListListDatatableComponent } from './components/advertiser-group-list-datatable/advertiser-group-list-datatable.component';

const DECLARATIONS = [AdvertiserGroupListListDatatableComponent];

const MODULES = [SharedModule];

@NgModule({
  declarations: DECLARATIONS,
  imports: [...MODULES],
  exports: [...MODULES, ...DECLARATIONS],
  providers: []
})
export class AdvertiserGroupModule {}
